// Node Module Imports
import React from 'react'

import {
  graphql, Link, navigate, useStaticQuery,
} from 'gatsby'
import styled from 'styled-components'

// Component Imports
import { colors, space } from '../../../style/design-system'
import Card from '../../elements/Card'

// Style imports

const BlogNav = ({ className, currentPath }) => {
  currentPath = currentPath[currentPath.length - 1] == '/'
    ? currentPath : `${currentPath}/`

  const data = useStaticQuery(graphql`{

    categories: allWpCategory(filter: {name: {nin: "Industry Insights"}}) {
      edges {
        node {
          name
          uri
        }
      }
    }

  }`)

  return (
    <>
      <div className="d-none d-xl-block">
        <Card className={`${className} p-0`}>
          <nav className="blog-nav">
            <ul className="m-0 p-0 list-style-none">
              <li className="blog-home">
                <Link
                  activeClassName="active"
                  to="/blog/"
                  className="d-block">
                  Blog Home
                </Link>
              </li>
              {data.categories.edges.map((cat, idx) => (
                <li key={idx}>
                  <Link
                    activeClassName="active"
                    to={`${cat.node.uri}`}
                    className="d-block">
                    {cat.node.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </Card>
      </div>
      <div className="d-xl-none py-8">
        <select
          className="pointer"
          value={currentPath}
          onChange={(e) => navigate(e.target.value)}>
          <option value="">Navigate the blog...</option>
          <option value="/blog/">Blog Home</option>
          {data.categories.edges.map((cat, idx) => (
            <option key={idx} value={cat.node.uri}>
              {cat.node.name}
            </option>
          ))}
        </select>
      </div>
    </>
  )
}

export default styled(BlogNav)`
  border-radius: 2px;
  font-size: 1rem;
  box-shadow: rgb(0 0 0 / 10%) 0px 0.1875rem 0.5rem;

  a.active {
    background-color: ${colors.dev.blue.d()};
    color: #fff;
  }

  a {
    border-radius: 2px;
    color: ${colors.dev.gray.b()};
    padding: ${space.c};
  }
`
